import type { Order } from '@nktkas/hyperliquid';
import { useQuery } from '@tanstack/react-query';

import { getInfoClient } from '@/lib/hooks/useHyperClient';
import { HexString } from '../config/wagmi';

const infoClient = getInfoClient();

export interface UseOpenOrdersProps {
  user: HexString;
}

export function useHLOpenOrders(user: HexString) {
  return useQuery<Order[]>({
    queryKey: ['openOrders', user],
    queryFn: async () => {
      const result = await infoClient.openOrders({ user });
      return result;
    },
    enabled: !!user,
    staleTime: 30 * 1000, // 30 seconds (orders change more frequently)
  });
}
